import { useEffect } from "react";

/**
 * Embeds the Zoho SalesIQ widget on the page.
 * The widget code is configured in the SalesIQ control panel.
 * This component injects the SalesIQ script and creates a placeholder
 * div for the widget. The SalesIQ script is loaded only once, and the
 * component cleans up after itself if unmounted.
 *
 * @returns {null} No visible component; just embeds the widget
 */
const ZohoIQWidget = () => {
  useEffect(() => {
    // Avoid multiple script injections
    if (document.getElementById("zsiqscript")) return;

    // Define the Zoho SalesIQ object
    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || {
      widgetcode:
        import.meta.env.VITE_ZOHO_WIDGETCODE,
      values: {},
      ready: function () {
        window.$zoho.salesiq.floatbutton.visible("hide");
        $zoho.salesiq.floatwindow.visible('hide')
      },
    };

    // Load the SalesIQ script
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "zsiqscript";
    script.defer = true;
    script.src = "https://salesiq.zoho.in/widget";

    document.body.appendChild(script);

    // Optional: Add a placeholder for the widget
    const widgetDiv = document.createElement("div");
    widgetDiv.id = "zsiqwidget";
    document.body.appendChild(widgetDiv);

    return () => {
      // Cleanup if needed
      const existingScript = document.getElementById("zsiqscript");
      if (existingScript) existingScript.remove();
      const widget = document.getElementById("zsiqwidget");
      if (widget) widget.remove();
    };
  }, []);

  return null; // No visible component; just embeds the widget
};

export default ZohoIQWidget;
